/**
 * Account API
 */

import { httpClient } from './httpClient'
import type { ApiResponse } from '../types'

export interface Account {
  id: string
  name: string
  customization?: {
    logo?: string
    primaryColor?: string
    impersonationEnabledDashboards?: string[]
  }
  kind?: string
  solution?: string
  isInstaller?: boolean
  systemsCount?: number
  parentID?: string
  modules?: string[]
  createdAt?: string
  updatedAt?: string
}

export interface AccountsPage {
  accounts: Account[]
  totalCount: number
}

export async function getAll(page: number, perPage = 100): Promise<ApiResponse<AccountsPage>> {
  try {
    const response = await httpClient.getClient().get<Account[]>('/accounts', {
      params: { full_hierarchy: true, kind: 'b2b', page, per_page: perPage, include: 'totalCount' },
      headers: { Accept: 'application/vnd.gridx.v2+json' },
    })
    const totalCount = parseInt(response.headers['x-total-count'] ?? '0', 10) || 0
    return { success: true, data: { accounts: response.data, totalCount } }
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Failed to list accounts',
      errorCode: error.code || 'UNKNOWN_ERROR',
      details: error.details,
    }
  }
}

export async function getById(accountID: string): Promise<ApiResponse<Account>> {
  try {
    const response = await httpClient.getClient().get<Account>(`/accounts/${accountID}`)
    return {
      success: true,
      data: response.data,
    }
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Failed to get account',
      errorCode: error.code || 'UNKNOWN_ERROR',
      details: error.details,
    }
  }
}
